import React from 'react'
import $ from 'jquery';
import _ from 'lodash';
import { find } from 'lodash';
import { Table, Column } from 'fixed-data-table';
// import fakeDataB from './fakeDataB';
import ReportWorkLogViewModalPs from './ReportWorkLogViewModalPs'
import DiscussionModal from '../workLog/DiscussionModal';
import DiscussionCell from '../workLog/DiscussionCell';
import SalesCasesModalCt from '../salesCases/SalesCasesModalCt';
import custJqAjax from '../../../commonJS/custJqAjax';
import { dateFormatCutter } from '../../../commonJS/formatters';

import {
	ExportBtn,
	SalesCasesTable,
	RepairServiceTable,
	FormQuotationTable,
	FormCostTable,
	FormMarginTable,
	FormOrderTable,
	FormGoodsTable,
	FormLadingTable,
	FormInvoiceTable,
	FormWarehouseTable
} from './ReportPs';

import {
	DataListWrapper,
	SortHeaderCell,
	TextCell,
	TimeWithoutHHmmssCell,
	SortTypes
} from '../../../commonComponents/DataTable/DataTablePs'


export default class ReportWorkLogTableCt extends React.Component {
	constructor(props) {
		super(props);

		this.ajaxsWip = [];

		this.handlers = {
			onRowClick: (e, rowIndex, sortedData) => {
				let id = sortedData.getObjectAt(rowIndex).sales_case_id;

				this.setState({
					selectedRowIndex: rowIndex,
					selectedItemId: id
				});
			}
		};

		this.state = {
			dataList: new DataListWrapper([], []),
			colSortDirs: {},
			workLog_panel_width: 0,
			workLog_panel_height: 0,
			showModal: false,
			selectedRowIndex: 0,
			selectedItemId: '',
			// for 討論功能
			showDiscussionModal: false,
			selectedLogId: ''
		}

		this.onClickExport = this.onClickExport.bind(this);
		this.onSortChange = this.onSortChange.bind(this);
		this.onClickCloseModal = this.onClickCloseModal.bind(this);
		this.onClickNext = this.onClickNext.bind(this);
		this.onClickPrevious = this.onClickPrevious.bind(this);

		this.onDiscussionsClick = (e, rowIndex, sortedData) => {
			e.stopPropagation();
			let id = sortedData.getObjectAt(rowIndex).work_id;

			this.setState({
				selectedLogId: id,
				selectedRowIndex: rowIndex,
				showDiscussionModal: true
			});
		};

		this.closeDiscussionModal = () => {
			this.setState({ showDiscussionModal: false });
		};
	}

	componentWillMount() {
		this.loadData();
	}

	loadData() {
		const dataParam = this.props.dataParam,
			reportType = this.props.reportType;

		let url;

		switch (reportType) {
			case 'workLog':
				url = `/api/W_SaleSky_WorkLog_Report_Get.php?${dataParam}`;
				break;
			case 'salesCases':
				url = `/api/M_Sales_Case_Data_Report_Get.php?${dataParam}`;
				break;
			case 'repairService':
				url = `/api/W_ServiceSky_RepairSky_Get.php?${dataParam}`;
				break;
			case 'repairServiceReview':
				url = `/api/M_ServiceSky_RepairSky_Review_Excel_Get.php?${dataParam}`;
				break;
			case 'formQuotation':
				url = `/api/M_Quotation_Data_Get.php?${dataParam}`;
				break;
			case 'formCost':
				url = `/api/M_Cost_Data_Get.php?${dataParam}`;
				break;
			case 'formMargin':
				url = `/api/M_Margin_Data_Get.php?${dataParam}`;
				break;
			case 'formOrder':
				url = `/api/M_Order_Jnh_Data_Get.php?${dataParam}`;
				break;
			case 'formGoods':
				url = `/api/M_Goods_Data_Get.php?${dataParam}`;
				break;
			case 'formLading':
				url = `/api/M_Lading_Data_Get.php?${dataParam}`;
				break;
			case 'formInvoice':
				url = `/api/M_Invoice_Data_Get.php?${dataParam}`;
				break;
			case 'formWarehouse':
				url = `/api/M_Warehouse_Data_Get.php?${dataParam}`;
				break;

			default:
		}

		custJqAjax({
			type: 'GET',
			ajaxsWip: this.ajaxsWip,
			custId: this.props.propsPackageFromSkyFamily.jqAjaxIdGenerator.getId(),
			url,
			success: response => {
				let defaultSortIndexes = [], dataCollection;

				if (response.status === '204') dataCollection = []
				else dataCollection = response.result;

				let size = dataCollection.length;

				const processedData = [],
					{
						optsCaseStatus,
						optsCaseType,
						optsCaseProbability,
						optsCaseSource,
						optsCasePayment,
						optsCaseRemindCyc,
						optsCasePurchmentStatus,
						optsCaseCurrency,
						optsTypeStatus,
						optsStage,
						optsTake,
						optsTakeType,
						optsModelStatus,
						optsDelivery,
						optsCurrency,
						optsTax,
						optsMchineType_sales,
						optsMchineType_svc,
						optsmTypeStatus,
						optsOrderStatus,
						optsPurchaseType,
						optsTradeStatus,
						optsbDelivery,
						optsbDeliveryStstus,
						optsLading,
						optsInvoicePurpose,
						optsWarehouse,
						optsInvoiceHandle,
						optsReason,
						optsBrand,
						optsReviewStatus,
						optsRepairStatus,
						optsAreaData,
						optsServiceData,
						optsSatisfactionData,
						optsContractData
					} = this.props;

				switch (reportType) {
					case 'workLog':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
						}
						break;
					case 'salesCases':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['case_createdate', 'case_quoteday', 'case_reminder_date']);
							// id mapping name 處理

							if (tempObj.case_stage) {
								const tarObj = find(optsCaseStatus, { value: tempObj.case_stage });
								tempObj['caseStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.case_type) {
								const tarObj = find(optsCaseType, { value: tempObj.case_type });
								tempObj['caseTypeName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.case_closerate) {
								const tarObj = find(optsCaseProbability, { value: tempObj.case_closerate });
								tempObj['caseProbabilityName'] = tarObj ? tarObj.label : '';
							}
							// #1
							if (tempObj.case_source) {
								const tarObj = find(optsCaseSource, { value: tempObj.case_source });
								tempObj['caseSourceName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.case_payment) {
								const tarObj = find(optsCasePayment, { value: tempObj.case_payment });
								tempObj['casePaymentName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.case_periodicity) {
								const tarObj = find(optsCaseRemindCyc, { value: tempObj.case_periodicity });
								tempObj['caseRemindCycName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.case_buyissue) {
								const tarObj = find(optsCasePurchmentStatus, { value: tempObj.case_buyissue });
								tempObj['casePurchmentStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.case_units) {
								const tarObj = find(optsCaseCurrency, { value: tempObj.case_units });
								tempObj['caseCurrencyName'] = tarObj ? tarObj.label : '';
							}

							// tempObj['caseStatusName'] = tempObj.case_stage ? find(optsCaseStatus, {value: tempObj.case_stage}).label : '';
							// tempObj['caseTypeName'] = tempObj.case_type ? find(optsCaseType, {value: tempObj.case_type}).label : '';
							// tempObj['caseProbabilityName'] = tempObj.case_closerate ? find(optsCaseProbability, {value: tempObj.case_closerate}).label : '';
							// tempObj['caseSourceName'] = tempObj.case_source ? find(optsCaseSource, {value: tempObj.case_source}).label : '';
							// tempObj['casePaymentName'] = tempObj.case_payment ? find(optsCasePayment, {value: tempObj.case_payment}).label : '';
							// tempObj['caseRemindCycName'] = tempObj.case_periodicity ? find(optsCaseRemindCyc, {value: tempObj.case_periodicity}).label : '';
							// tempObj['casePurchmentStatusName'] = tempObj.case_buyissue ? find(optsCasePurchmentStatus, {value: tempObj.case_buyissue}).label : '';

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'repairService':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['request_date']);

							if (tempObj.status) {
								const tarObj = find(optsRepairStatus, { value: tempObj.status });
								tempObj['status_name'] = tarObj ? tarObj.label : '';
								tempObj['status_color'] = tarObj ? tarObj.color : '';
							}

							if (tempObj.area_type_id) {
								const tarObj = find(optsAreaData, { value: tempObj.area_type_id });
								tempObj['area_type_name'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.service_type_id) {
								const filterServiceTypeId = tempObj.service_type_id.split(',');
								let serviceTypeString = '';

								for (let idxServiceTypeId = 0; idxServiceTypeId < filterServiceTypeId.length; idxServiceTypeId++) {
									const tarObj = find(optsServiceData, { value: $.trim(filterServiceTypeId[idxServiceTypeId]) });

									serviceTypeString += tarObj ? tarObj.label + '、' : '';
								}
								tempObj['service_type_name'] = serviceTypeString ? serviceTypeString.substring(0, serviceTypeString.length - 1) : '';
							}

							if (tempObj.satisfaction_id) {
								const tarObj = find(optsSatisfactionData, { value: tempObj.satisfaction_id });
								tempObj['satisfaction_name'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.warranty_type_id) {
								const tarObj = find(optsContractData, { value: tempObj.warranty_type_id });
								tempObj['warranty_type_name'] = tarObj ? tarObj.label : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'formQuotation':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['quotation_date', 'expiry_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_type_id) {
								const tarObj = find(optsTypeStatus, { value: tempObj.b_type_id });
								tempObj['typeName'] = tarObj ? tarObj.label : '';

								if (tarObj) {
									switch (tempObj.b_type_id) {
										case '1':
											if (tempObj.b_machine_type) {
												const tarObj = find(optsMchineType_sales, { value: tempObj.b_machine_type });
												tempObj['machineName'] = tarObj ? tarObj.label : '';
											}
											break;
										case '2':
											if (tempObj.b_machine_type) {
												const tarObj = find(optsMchineType_svc, { value: tempObj.b_machine_type });
												tempObj['machineName'] = tarObj ? tarObj.label : '';
											}
											break;

										default:
									}
								}
							}

							if (tempObj.b_stage_id) {
								const tarObj = find(optsStage, { value: tempObj.b_stage_id });
								tempObj['stageName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_take_id) {
								const tarObj = find(optsTake, { value: tempObj.b_take_id });
								tempObj['takeName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_model_id) {
								const tarObj = find(optsModelStatus, { value: tempObj.b_model_id });
								tempObj['modelName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_delivery_id) {
								const tarObj = find(optsDelivery, { value: tempObj.b_delivery_id });
								tempObj['deliveryName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_currency_id) {
								const tarObj = find(optsCurrency, { value: tempObj.b_currency_id });
								tempObj['currencyName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_tax_id) {
								const tarObj = find(optsTax, { value: tempObj.b_tax_id });
								tempObj['taxName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.brand_id) {
								let brandID = tempObj.brand_id, brandArr = brandID.split(','), brandString = '';

								for (let idxBrandArr = 0; idxBrandArr < brandArr.length; idxBrandArr++) {
									const tarObj = find(optsBrand, { value: $.trim(brandArr[idxBrandArr]) });

									brandString += tarObj ? tarObj.label + '、' : '';
								}
								tempObj['brandName'] = brandString ? brandString.substring(0, brandString.length - 1) : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'formCost':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['quotation_date', 'expiry_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_type_id) {
								const tarObj = find(optsTypeStatus, { value: tempObj.b_type_id });
								tempObj['typeName'] = tarObj ? tarObj.label : '';

								if (tarObj) {
									switch (tempObj.b_type_id) {
										case '1':
											if (tempObj.b_machine_type) {
												const tarObj = find(optsMchineType_sales, { value: tempObj.b_machine_type });
												tempObj['machineName'] = tarObj ? tarObj.label : '';
											}
											break;
										case '2':
											if (tempObj.b_machine_type) {
												const tarObj = find(optsMchineType_svc, { value: tempObj.b_machine_type });
												tempObj['machineName'] = tarObj ? tarObj.label : '';
											}
											break;

										default:
									}
								}
							}

							if (tempObj.b_currency_id) {
								const tarObj = find(optsCurrency, { value: tempObj.b_currency_id });
								tempObj['currencyName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_tax_id) {
								const tarObj = find(optsTax, { value: tempObj.b_tax_id });
								tempObj['taxName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.brand_id) {
								let brandID = tempObj.brand_id, brandArr = brandID.split(','), brandString = '';

								for (let idxBrandArr = 0; idxBrandArr < brandArr.length; idxBrandArr++) {
									const tarObj = find(optsBrand, { value: $.trim(brandArr[idxBrandArr]) });

									brandString += tarObj ? tarObj.label + '、' : '';
								}
								tempObj['brandName'] = brandString ? brandString.substring(0, brandString.length - 1) : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'formMargin':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['create_date', 'open_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_mtype_id) {
								const tarObj = find(optsmTypeStatus, { value: tempObj.b_mtype_id });
								tempObj['typeName'] = tarObj ? tarObj.label : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'formOrder':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['quotation_date', 'expiry_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_type_id) {
								const tarObj = find(optsTypeStatus, { value: tempObj.b_type_id });
								tempObj['typeName'] = tarObj ? tarObj.label : '';

								if (tarObj) {
									switch (tempObj.b_type_id) {
										case '1':
											if (tempObj.b_machine_type) {
												const tarObj = find(optsMchineType_sales, { value: tempObj.b_machine_type });
												tempObj['machineName'] = tarObj ? tarObj.label : '';
											}
											break;
										case '2':
											if (tempObj.b_machine_type) {
												const tarObj = find(optsMchineType_svc, { value: tempObj.b_machine_type });
												tempObj['machineName'] = tarObj ? tarObj.label : '';
											}
											break;

										default:
									}
								}
							}

							if (tempObj.b_order_id) {
								const tarObj = find(optsOrderStatus, { value: tempObj.b_order_id });
								tempObj['orderName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_take_id) {
								const tarObj = find(optsTake, { value: tempObj.b_take_id });
								tempObj['takeName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_model_id) {
								const tarObj = find(optsModelStatus, { value: tempObj.b_model_id });
								tempObj['modelName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_delivery_id) {
								const tarObj = find(optsDelivery, { value: tempObj.b_delivery_id });
								tempObj['deliveryName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_currency_id) {
								const tarObj = find(optsCurrency, { value: tempObj.b_currency_id });
								tempObj['currencyName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_tax_id) {
								const tarObj = find(optsTax, { value: tempObj.b_tax_id });
								tempObj['taxName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.brand_id) {
								let brandID = tempObj.brand_id, brandArr = brandID.split(','), brandString = '';

								for (let idxBrandArr = 0; idxBrandArr < brandArr.length; idxBrandArr++) {
									const tarObj = find(optsBrand, { value: $.trim(brandArr[idxBrandArr]) });

									brandString += tarObj ? tarObj.label + '、' : '';
								}
								tempObj['brandName'] = brandString ? brandString.substring(0, brandString.length - 1) : '';
							}

							processedData.push(tempObj);
						}
						dataCollection = processedData;
						break;
					case 'formGoods':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['purchase_date', 'contract_date', 'delivery_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_model_id) {
								const tarObj = find(optsModelStatus, { value: tempObj.b_model_id });
								tempObj['modelName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_currency_id) {
								const tarObj = find(optsCurrency, { value: tempObj.b_currency_id });
								tempObj['currencyName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_case_status) {
								const tarObj = find(optsCaseStatus, { value: tempObj.b_case_status });
								tempObj['caseStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_purchase_type) {
								const tarObj = find(optsPurchaseType, { value: tempObj.b_purchase_type });
								tempObj['purchaseName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_trade_id) {
								const tarObj = find(optsTradeStatus, { value: tempObj.b_trade_id });
								tempObj['tradeName'] = tarObj ? tarObj.label : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'formLading':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['create_date', 'delivery_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_model_id) {
								const tarObj = find(optsModelStatus, { value: tempObj.b_model_id });
								tempObj['modelName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_delivery_type) {
								const tarObj = find(optsbDelivery, { value: tempObj.b_delivery_type });
								tempObj['deliveryName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_delivery_status) {
								const tarObj = find(optsbDeliveryStstus, { value: tempObj.b_delivery_status });
								tempObj['deliveryStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_lading_type) {
								const tarObj = find(optsLading, { value: tempObj.b_lading_type });
								tempObj['ladingName'] = tarObj ? tarObj.label : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'formInvoice':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['delivery_date', 'create_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_model_id) {
								const tarObj = find(optsModelStatus, { value: tempObj.b_model_id });
								tempObj['modelName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_delivery_type) {
								const tarObj = find(optsbDelivery, { value: tempObj.b_delivery_type });
								tempObj['deliveryName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_delivery_status) {
								const tarObj = find(optsbDeliveryStstus, { value: tempObj.b_delivery_status });
								tempObj['deliveryStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_invoice_purpose) {
								const tarObj = find(optsInvoicePurpose, { value: tempObj.b_invoice_purpose });
								tempObj['invoicePurposeName'] = tarObj ? tarObj.label : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;
					case 'formWarehouse':
						for (let i = 0; i < size; i++) {
							defaultSortIndexes.push(i);
							// 時間格式處理
							const tempObj = dateFormatCutter(dataCollection[i], ['storage_date', 'create_date']);

							if (tempObj.review_status_id) {
								const tarObj = find(optsReviewStatus, { value: tempObj.review_status_id });
								tempObj['reviewStatusName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_warehouse_type) {
								const tarObj = find(optsWarehouse, { value: tempObj.b_warehouse_type });
								tempObj['warehouseName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_take_type) {
								const tarObj = find(optsTakeType, { value: tempObj.b_take_type });
								tempObj['takeTypeName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_invoice_handle) {
								const tarObj = find(optsInvoiceHandle, { value: tempObj.b_invoice_handle });
								tempObj['invoiceHandleName'] = tarObj ? tarObj.label : '';
							}

							if (tempObj.b_reason_id) {
								const tarObj = find(optsReason, { value: tempObj.b_reason_id });
								tempObj['reasonName'] = tarObj ? tarObj.label : '';
							}

							processedData.push(tempObj);
						}

						dataCollection = processedData;
						break;

					default:
				}

				this.setState({
					dataList: new DataListWrapper(defaultSortIndexes, dataCollection, reportType === 'salesCases' ? 'company_id' : undefined),
					unsortedDataList: new DataListWrapper(defaultSortIndexes, dataCollection),
					defaultSortIndexes: defaultSortIndexes,
				});

				if (size === 0) {
					this.setState({ noData: true });
				}
			},
			error: error => { }
		});
	}

	componentDidMount() {
		this.getColumnWidth();
	}

	componetWillUnmount() {
		this.props.propsPackageFromSkyFamily.ajaxAborter(this.ajaxsWip);
	}

	getColumnWidth() {
		let workLog_panel_width = parseFloat($('.panel-body').css('width')) - 30;
		let div_sidebar_container_pane_third_height = parseFloat($('#div-sidebar-container-pane-third').css('height'));
		let workLog_panel_height = div_sidebar_container_pane_third_height - 220;
		this.setState({
			workLog_panel_width: workLog_panel_width,
			workLog_panel_height: workLog_panel_height,
		});
	}

	onClickExport() {
		const dataArr = this.state.dataList._data,
			reportType = this.props.reportType;

		// 不需要的欄位, 表頭, 檔名
		// mirror 寫的報表不需要的欄位似乎不需要特別指出，有定義的才會輸出
		// 但她又有列出，找時間釐清一下
		let keysToDelete, thead, fileName;

		switch (reportType) {
			case 'workLog':
				keysToDelete = [
					'company_id',
					'contact_id',
					'department_name',
					'model_id',
					'nature_id',
					'next_start_date',
					'next_end_date',
					'progress_id',
					'project_progress_id',
					'reg_time',
					'visit_end_date',
					'work_group_id',
					'work_owner_id',
					'work_phone'
				];

				fileName = 'workLog.csv';

				thead = [
					'拜訪日期',
					'部門',
					'建立人',
					'客戶',
					'聯絡人',
					'職稱',
					'email',
					'手機',
					'分機',
					'產品',
					'工作性質',
					'工作內容',
					'進度',
					'專案進度'
				];
				break;
			case 'salesCases':
				keysToDelete = [];

				fileName = 'salesCases.csv';

				thead = [
					// 外部清單
					'建立日期',
					'公司名稱',
					'個案狀態',
					'採購狀態',
					'結案機率',
					'建立者',
					'個案分類',
					'報價日期',
					'預計成交日',
					'備註',
					// 其他
					'聯絡人',
					'聯絡電話',
					'行動電話',
					'傳真',
					'電子郵件',
					'部門',
					'客戶來源',
					'產品描述',
					'有效天數',
					'幣別',
					'付款方式',
					'預計成交價',
					'下次提醒',
					'週期通知',
					'競爭者',
					'議價對策',
					'建立者群組id',
					'銷售個案id'
				];
				break;
			case 'repairService':
				keysToDelete = [];

				fileName = '服務單.csv';

				thead = [
					'單號',
					'單況',
					'填單日期',
					'客戶全稱',
					'儀器名稱',
					'序號',
					'類別',
					'安排/維修日期',
					'離開日期',
					'負責工程師',
					'叫修內容(概要)',
					'處理狀況',
					'處理結論',
					'結果',
					'收費內容',
					'備註'
					// '狀態',
					// '報修日期',
					// '維修單編號',
					// '區域',
					// '公司',
					// '產品',
					// '產品序號',
					// '報修內容',
					// '建立者',
					// '服務人員',
					// '保固/維護合約'
				];
				break;
			case 'formQuotation':
				keysToDelete = [];

				fileName = '估價單.csv';

				thead = [
					'單號',
					'狀態',
					'表單類型',
					'案況進度',
					'預計取件',
					'商業模式',
					'申請人',
					'報價日期',
					'有效日期',
					'取件方式',
					'客戶編號',
					'客戶名稱',
					'客戶地址',
					'聯絡人',
					'聯絡電話',
					'Email',
					'幣別',
					'稅別',
					'產品類型',
					'廠牌',
					'建立者'
				];
				break;
			case 'formCost':
				keysToDelete = [];

				fileName = '成本分析表.csv';

				thead = [
					'單號',
					'狀態',
					'表單類型',
					'申請人',
					'報價日期',
					'有效日期',
					'客戶編號',
					'客戶名稱',
					'客戶地址',
					'聯絡人',
					'聯絡電話',
					'Email',
					'幣別',
					'稅別',
					'產品類型',
					'廠牌',
					'建立者'
				];
				break;
			case 'formMargin':
				keysToDelete = [];

				fileName = '保證金申請單.csv';

				thead = [
					'單號',
					'狀態',
					'表單類型',
					'申請人',
					'案號',
					'客戶編號',
					'客戶名稱',
					'採購單位',
					'案名',
					'英文品名',
					'建立日期',
					'開標日期',
					'建立者'
				];
				break;
			case 'formOrder':
				keysToDelete = [];

				fileName = '訂單.csv';

				thead = [
					'單號',
					'狀態',
					'表單類型',
					'訂單確認方式',
					'預計取件',
					'商業模式',
					'申請人',
					'報價日期',
					'有效日期',
					'客戶編號',
					'客戶名稱',
					'客戶地址',
					'聯絡人',
					'聯絡電話',
					'Email',
					'幣別',
					'稅別',
					'產品類型',
					'廠牌',
					'建立者'
				];
				break;
			case 'formGoods':
				keysToDelete = [];

				fileName = '貨品申購書.csv';

				thead = [
					'單號',
					'狀態',
					'商業模式',
					'單況',
					'申請人',
					'用途',
					'訂購日期',
					'客戶編號',
					'客戶名稱',
					'聯絡人',
					'合約書交貨期',
					'期望交貨期',
					'幣別',
					'貿易條件',
					'得標金額',
					'建立者'
				];
				break;
			case 'formLading':
				keysToDelete = [];

				fileName = '領貨單.csv';

				thead = [
					'單號',
					'狀態',
					'商業模式',
					'申請人',
					'建立日期',
					'客戶編號',
					'客戶名稱',
					'聯絡人',
					'連絡電話',
					'送貨地址',
					'發票地址',
					'寄送方式',
					'寄送日期',
					'寄送狀態',
					'類型',
					'原因',
					'建立者'
				];
				break;
			case 'formInvoice':
				keysToDelete = [];

				fileName = '發票申請單.csv';

				thead = [
					'單號',
					'狀態',
					'商業模式',
					'申請人',
					'建立日期',
					'客戶編號',
					'客戶名稱',
					'聯絡人',
					'連絡電話',
					'發票地址',
					'寄送方式',
					'寄送日期',
					'寄送狀態',
					'類型',
					'原因',
					'發票號碼',
					'銷貨單單據號碼',
					'建立者'
				];
				break;
			case 'formWarehouse':
				keysToDelete = [];

				fileName = '入庫單.csv';

				thead = [
					'單號',
					'狀態',
					'類別',
					'申請人',
					'建立日期',
					'入庫日期',
					'客戶編號',
					'客戶名稱',
					'聯絡人',
					'領貨別',
					'單據號碼',
					'發票處理方式',
					'發票號碼',
					'退貨原因',
					'備註',
					'建立者'
				];
				break;

			default:
		}

		let dataListRomovedByKey = [];//拿掉部分key的objects
		for (let i = 0; i < dataArr.length; i++) {
			let newObj = this.removeByKey(dataArr[i], keysToDelete);
			dataListRomovedByKey.push(newObj);
		}

		let arrayOfArrays = this.objectToArray(dataListRomovedByKey);//把objects依照表頭順序轉成array

		arrayOfArrays.unshift(thead);//把表頭放進陣列第一個

		this.exportToCsv(fileName, arrayOfArrays);
	}

	removeByKey(myObj, keysToDelete) {//把數個key從一個object移除的工具
		let newObj = myObj;

		for (let i = 0; i < keysToDelete.length; i++) {
			newObj = removeKeysInOneObject(newObj, i);
		}

		function removeKeysInOneObject(newObj, i) {
			return Object.keys(newObj).filter(key => key !== keysToDelete[i]).reduce((result, current) => {
				result[current] = newObj[current];
				return result;
			}, {});
		}
		return newObj;
	}

	objectToArray(arrayOfObjects) {//將數個objects轉成數個arrays
		let arrayOfArrays = [];
		for (let i = 0; i < arrayOfObjects.length; i++) {
			//欄位順序, 同onClickExport()的thead, 若要更動欄位順序或增減欄位, 兩個都要改
			let arrSchema;
			const reportType = this.props.reportType;

			switch (reportType) {
				case 'workLog':
					arrSchema = [
						'visit_start_date',
						'work_group_name',
						'work_owner_name',
						'company_name',
						'contact_name',
						'job_title',
						'email',
						'cellphone',
						'ext',
						'model_name',
						'nature_name',
						'content',
						'progress_name',
						'project_progress_name'
					];
					break;
				case 'salesCases':
					arrSchema = [
						// 外部清單
						'case_createdate',
						'company_name',
						'caseStatusName',
						'casePurchmentStatusName',
						'caseProbabilityName',
						'case_owner_name',
						'caseTypeName',
						'case_quoteday',
						'case_dealday',
						'case_remark',
						// 其他
						'contact_name',
						'work_phone',
						'cell_phone',
						'fax',
						'email',
						'group_name',
						// 'case_source',
						'caseSourceName',
						'case_product_description',
						'case_validly',
						// case_units
						'caseCurrencyName',
						// 'case_payment',
						'casePaymentName',
						'case_dealprice',
						'case_reminder_date',
						// 'case_periodicity',
						'caseRemindCycName',
						'case_competitor',
						'case_strategy',
						'group_id',
						'sales_case_id'
					];
					break;
				case 'repairService':
					arrSchema = [
						'repair_id',
						'status_name',
						'request_date',
						'company_name',
						'model_name',
						'serial_number',
						'service_type_name',
						'start_date',
						'repair_date',
						'fix_user_name',
						'issue_description',
						'solution_description',
						'repair_result',
						'satisfaction_name',
						'cost_type',
						'remark'
					];
					break;
				case 'formQuotation':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'typeName',
						'stageName',
						'takeName',
						'modelName',
						'request_name',
						'quotation_date',
						'expiry_date',
						'deliveryName',
						'customer_id',
						'customer_name',
						'customer_address',
						'contact_name',
						'contact_tel',
						'contact_email',
						'currencyName',
						'taxName',
						'machineName',
						'brandName',
						'creator_name'
					];
					break;
				case 'formCost':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'typeName',
						'request_name',
						'quotation_date',
						'expiry_date',
						'customer_id',
						'customer_sname',
						'customer_address',
						'contact_name',
						'contact_tel',
						'contact_email',
						'currencyName',
						'taxName',
						'machineName',
						'brandName',
						'creator_name'
					];
					break;
				case 'formMargin':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'typeName',
						'request_name',
						'case_id',
						'customer_id',
						'customer_name',
						'department',
						'case_name',
						'product_ename',
						'create_date',
						'open_date',
						'creator_name'
					];
					break;
				case 'formOrder':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'typeName',
						'orderName',
						'takeName',
						'modelName',
						'request_name',
						'quotation_date',
						'expiry_date',
						'customer_id',
						'customer_name',
						'customer_address',
						'contact_name',
						'contact_tel',
						'contact_email',
						'currencyName',
						'taxName',
						'machineName',
						'brandName',
						'creator_name'
					];
					break;
				case 'formGoods':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'modelName',
						'caseStatusName',
						'request_name',
						'purchaseName',
						'purchase_date',
						'customer_id',
						'customer_name',
						'contact_name',
						'contract_date',
						'delivery_date',
						'currencyName',
						'tradeName',
						'get_amount',
						'creator_name'
					];
					break;
				case 'formLading':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'modelName',
						'request_name',
						'create_date',
						'customer_id',
						'customer_name',
						'contact_name',
						'work_phone',
						'delivery_address',
						'invoice_address',
						'deliveryName',
						'delivery_date',
						'deliveryStatusName',
						'ladingName',
						'reason',
						'creator_name'
					];
					break;
				case 'formInvoice':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'modelName',
						'request_name',
						'create_date',
						'customer_id',
						'customer_name',
						'contact_name',
						'work_phone',
						'invoice_address',
						'deliveryName',
						'delivery_date',
						'deliveryStatusName',
						'invoicePurposeName',
						'reason',
						'invoice_number',
						'order_number',
						'creator_name'
					];
					break;
				case 'formWarehouse':
					arrSchema = [
						'doc_id',
						'reviewStatusName',
						'warehouseName',
						'request_name',
						'create_date',
						'storage_date',
						'customer_id',
						'customer_name',
						'contact_name',
						'takeTypeName',
						'borrow_number',
						'invoiceHandleName',
						'invoice_number',
						'reasonName',
						'warehouse_remark',
						'creator_name'
					];
					break;

				default:
			}

			let arrResult = this.orderedValues(arrSchema, arrayOfObjects[i]);
			arrayOfArrays.push(arrResult);
		}
		return arrayOfArrays;
	}

	orderedValues(arrSchema, obj) {//一個object轉成array時, 依照arrSchema的順序排列的工具
		var arrResult = [];
		for (var i = 0; i < arrSchema.length; i++)
			arrResult[i] = obj[arrSchema[i]];

		return arrResult;
	}

	exportToCsv(filename, rows) {
		var processRow = function (row) {
			var finalVal = '';
			for (var j = 0; j < row.length; j++) {
				var innerValue = !row[j] ? '' : row[j].toString();
				if (row[j] instanceof Date) {
					innerValue = row[j].toLocaleString();
				};
				var result = innerValue.replace(/"/g, '""');
				if (result.search(/("|,|\n)/g) >= 0)
					result = '"' + result + '"';
				if (j > 0) finalVal += ',';

				finalVal += result;
			}
			return finalVal + '\n';
		};

		var csvFile = '';
		for (var i = 0; i < rows.length; i++) {
			csvFile += processRow(rows[i]);
		}

		var BOM = '\uFEFF';//讓MS Excel能讀取utf-8
		csvFile = BOM + csvFile;
		var blob = new Blob([csvFile], { type: 'text/csv;charset=utf-8' });
		if (navigator.msSaveBlob) { // IE 10+
			navigator.msSaveBlob(blob, filename);
		} else {
			var link = document.createElement('a');
			if (link.download !== undefined) { // feature detection
				// Browsers that support HTML5 download attribute
				var url = URL.createObjectURL(blob);
				link.setAttribute('href', url);
				link.setAttribute('download', filename);
				link.style.visibility = 'hidden';
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
			}
		}
	}

	onRowClick(row, rowIndex) {
		const obj = {};
		if (this.props.reportType === 'salesCases') {
			obj.selectedItemId = row.sales_case_id;
		}

		this.setState({
			showModal: true,
			selectedRowIndex: rowIndex,
			...obj
		});
	}

	onClickCloseModal() {
		this.setState({
			showModal: false,
		});
	}

	onClickNext() {
		let searchResultLength = this.state.dataList._data.length;
		this.setState({
			selectedRowIndex: this.state.selectedRowIndex === searchResultLength - 1 ? this.state.selectedRowIndex : this.state.selectedRowIndex + 1
		});
	}

	onClickPrevious() {
		this.setState({
			selectedRowIndex: this.state.selectedRowIndex === 0 ? this.state.selectedRowIndex : this.state.selectedRowIndex - 1
		});
	}

	onSortChange(columnKey, sortDir) {
		let sortIndexes = this.state.defaultSortIndexes.slice();

		sortIndexes.sort((indexA, indexB) => {
			/*eslint no-useless-escape: 'off'*/
			let valueA = this.state.unsortedDataList.getObjectAt(indexA)[columnKey].replace(/[\ |\-|\:|\?]/g, '');
			let valueB = this.state.unsortedDataList.getObjectAt(indexB)[columnKey].replace(/[\ |\-|\:|\?]/g, '');
			let sortVal = 0;
			if (valueA > valueB) {
				sortVal = 1;
			}
			if (valueA < valueB) {
				sortVal = -1;
			}
			if (sortVal !== 0 && sortDir === SortTypes.ASC) {
				sortVal *= -1;
			}

			return sortVal;
		});

		this.setState({
			dataList: new DataListWrapper(sortIndexes, this.state.unsortedDataList._data),
			colSortDirs: {
				[columnKey]: sortDir,
			},
		});
	}
	render() {
		const { languageData, languageCode } = window.myConsts;

		const { reportType } = this.props;

		let {
			dataList,
			workLog_panel_width,
			workLog_panel_height,
			noData,
			showModal,
			colSortDirs,
			selectedRowIndex,
			selectedItemId
		} = this.state;

		if (noData === true) {
			return <div>您所輸入的條件查無資料</div>;
		}

		let t1, t2, t3, t4, t5, t6, t7, t8, t9, t10, t11,
			sw1, sw2, sw3, sw4,
			glow1, glow2, glow3, glow4,
			showDiscussCell, modal;

		switch (reportType) {
			case 'workLog':
				t1 = '拜訪日期';
				t2 = '部門';
				t3 = '建立人';
				t4 = '公司名稱';
				t5 = '聯絡人';
				t6 = '職稱';
				t7 = '產品';
				t8 = '工作性質';
				t9 = '內容';
				t10 = '進度';
				t11 = '專案進度';
				sw1 = 100;
				sw2 = 150;
				sw3 = 160;
				sw4 = 100;
				glow1 = glow2 = glow4 = 0;
				glow3 = 1;
				showDiscussCell = true;

				modal = <ReportWorkLogViewModalPs
					userName={this.props.userName}
					onDiscussionsClick={this.onDiscussionsClick}
					showWorkLogViewModal={showModal}
					onClickCloseModal={this.onClickCloseModal}
					selectedRow={this.state.dataList.getObjectAt(selectedRowIndex)}
					workLogSortedData={this.state.dataList}
					onClickNext={this.onClickNext}
					onClickPrevious={this.onClickPrevious}
					selectedRowIndex={selectedRowIndex}
					searchResultLength={this.state.dataList._data.length} />
				break;
			case 'salesCases':
				const
					{
						propsPackageFromSkyFamily,
						loadOptions,
						optsCompany,
						optsCaseStatus,
						optsCaseType,
						optsCaseProbability,
						optsCaseSource,
						optsCasePayment,
						optsCaseRemindCyc,
						optsCasePurchmentStatus,
						optsCaseCurrency,
						grandStateHandler,
						stateHandler,
						parentStateHandler,
						userId,
						userName
					} = this.props,
					modalProps = {
						propsPackageFromSkyFamily,
						loadOptions,
						optsCompany,
						optsCaseStatus,
						optsCaseType,
						optsCaseProbability,
						optsCaseSource,
						optsCasePayment,
						optsCaseRemindCyc,
						optsCasePurchmentStatus,
						optsCaseCurrency,
						grandStateHandler,
						stateHandler,
						parentStateHandler,
						userId,
						userName
					}
				modal = <SalesCasesModalCt
					closeModal={this.onClickCloseModal}
					// modal更新的始終是篩選前的資料
					sortedData={dataList}
					// for pagerUd
					filteredSortedData={dataList}
					// 使用table裡面的
					selectedRowIndex={selectedRowIndex}
					selectedItemId={selectedItemId}
					onRowClick={this.handlers.onRowClick}
					productProps={{ productSortedData: { _data: true } }}
					optsModel={[]}
					viewOnly={true}
					{...modalProps} />
				break;
			case 'repairService':
			case 'formQuotation':
			case 'formCost':
			case 'formMargin':
			case 'formOrder':
			case 'formGoods':
			case 'formLading':
			case 'formInvoice':
			case 'formWarehouse':
				break;

			default:
		}

		const width = this.props.isBigSideBar ? workLog_panel_width : (workLog_panel_width + 186),
			height = workLog_panel_height;

		return (
			<div>
				<ExportBtn onClick={this.onClickExport} />
				{
					reportType === 'formQuotation' ?
						<FormQuotationTable
							dataObj={dataList}
							// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
							width={width}
							height={height}
							onSortChange={this.onSortChange}
							sortDir={colSortDirs} />
						: reportType === 'formCost' ?
							<FormCostTable
								dataObj={dataList}
								// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
								width={width}
								height={height}
								onSortChange={this.onSortChange}
								sortDir={colSortDirs} />
							: reportType === 'formMargin' ?
								<FormMarginTable
									dataObj={dataList}
									// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
									width={width}
									height={height}
									onSortChange={this.onSortChange}
									sortDir={colSortDirs} />
								: reportType === 'formOrder' ?
									<FormOrderTable
										dataObj={dataList}
										// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
										width={width}
										height={height}
										onSortChange={this.onSortChange}
										sortDir={colSortDirs} />
									: reportType === 'formGoods' ?
										<FormGoodsTable
											dataObj={dataList}
											// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
											width={width}
											height={height}
											onSortChange={this.onSortChange}
											sortDir={colSortDirs} />
										: reportType === 'formLading' ?
											<FormLadingTable
												dataObj={dataList}
												// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
												width={width}
												height={height}
												onSortChange={this.onSortChange}
												sortDir={colSortDirs} />
											: reportType === 'formInvoice' ?
												<FormInvoiceTable
													dataObj={dataList}
													// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
													width={width}
													height={height}
													onSortChange={this.onSortChange}
													sortDir={colSortDirs} />
												: reportType === 'formWarehouse' ?
													<FormWarehouseTable
														dataObj={dataList}
														// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
														width={width}
														height={height}
														onSortChange={this.onSortChange}
														sortDir={colSortDirs} />
													: reportType === 'salesCases' ?
														<SalesCasesTable
															dataObj={dataList}
															// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
															width={width}
															height={height}
															onSortChange={this.onSortChange}
															sortDir={colSortDirs} />
														: reportType === 'repairService' ?
															<RepairServiceTable
																dataObj={dataList}
																// onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}
																width={width}
																height={height}
																onSortChange={this.onSortChange}
																sortDir={colSortDirs} />
															:
															<Table
																width={width}
																height={height}
																rowHeight={50}
																headerHeight={50}
																rowsCount={dataList.getSize()}
																onRowClick={(event, rowIndex) => this.onRowClick(dataList.getObjectAt(rowIndex), rowIndex)}>
																<Column
																	columnKey='visit_start_date'
																	flexGrow={0}
																	fixed={true}
																	width={100}
																	cell={<TimeWithoutHHmmssCell sortedData={dataList} />}
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.visit_start_date}>
																			{t1}
																		</SortHeaderCell>
																	}
																/>
																<Column
																	columnKey='work_group_name'
																	flexGrow={0}
																	fixed={true}
																	width={100}
																	cell={<TimeWithoutHHmmssCell sortedData={dataList} />}
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.department_name}>
																			{t2}
																		</SortHeaderCell>
																	}
																/>
																<Column
																	columnKey='work_owner_name'
																	fixed={true}
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.work_owner_name}>
																			{t3}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={100}
																	flexGrow={0}
																/>
																<Column
																	columnKey='company_name'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.company_name}>
																			{t4}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	flexGrow={0}
																	width={reportType === 'workLog' ? 100 : 120}
																/>
																<Column
																	columnKey='contact_name'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.contact_name}>
																			{t5}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={100}
																	flexGrow={0}
																/>
																<Column
																	columnKey='job_title'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.job_title}>
																			{t6}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={100}
																	flexGrow={0}
																/>
																<Column
																	columnKey='model_name'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.model_name}>
																			{t7}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={sw1}
																	flexGrow={glow1}
																/>
																<Column
																	columnKey='nature_name'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.nature_name}>
																			{t8}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={sw2}
																	flexGrow={glow2}
																/>
																<Column
																	columnKey='content'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.content}>
																			{t9}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={sw3}
																	flexGrow={glow3}
																/>
																<Column
																	columnKey='progress_name'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.progress_name}>
																			{t10}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={100}
																	flexGrow={0}
																/>
																<Column
																	columnKey='project_progress_name'
																	header={
																		<SortHeaderCell
																			onSortChange={this.onSortChange}
																			sortDir={colSortDirs.project_progress_name}>
																			{t11}
																		</SortHeaderCell>
																	}
																	cell={<TextCell sortedData={dataList} />}
																	width={sw4}
																	flexGrow={glow4}
																/>
																{
																	showDiscussCell ?
																		<Column
																			columnKey='worklog_discuss_count'
																			header={
																				<SortHeaderCell
																					onSortChange={this.onSortChange}
																					sortDir={colSortDirs.worklog_discuss_count}>
																					{'討論'}
																				</SortHeaderCell>
																			}
																			cell={
																				<DiscussionCell sortedData={dataList}
																					onClick={this.onDiscussionsClick}
																					style={{ textAlign: 'center' }}
																					className='worklog-discussion-cell' />
																			}
																			flexGrow={0}
																			width={80} />
																		: ''
																}
															</Table>
				}

				{showModal ? modal : ''}

				{
					this.state.showDiscussionModal ?
						<DiscussionModal
							languageCode={languageCode}
							languageData={languageData}
							show={this.state.showDiscussionModal}
							closeModal={this.closeDiscussionModal}
							worklogId={this.state.selectedLogId}
							rowIndex={this.state.selectedRowIndex}
							// stateHandler={this.props.stateHandler}
							sortedData={dataList} />
						: ''
				}
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./src/salesky/routes/report/ReportWorkLogTableCt.jsx